<template>
  <div v-if="selectedProduct != undefined">
    <h5 class="pt-2 product-name">
      {{ selectedProduct.Description }}<span v-if="prod.colors && prod.colors.length > 1">, {{selectedProduct.trueColour}}</span><span v-else-if="prod.sizes && prod.sizes.length > 1">, {{selectedProduct.Size}}</span>
    </h5>

    <h5 v-if="isUoMNumber(selectedProduct.UoM)">{{selectedProduct.UoM}}</h5>
    <h5 class="my-4" style="color:red;">AED&nbsp;{{ this.getProdPrice(selectedProduct.Price) }}</h5>
    <div class="py-2 order--buttons">
      <b-button class="order-btns" size="sm" @click="decrementOrder">
        <font-awesome-icon class="order-icons" icon="minus"></font-awesome-icon>
      </b-button>
      <input
        class="btn order-btns btn-sm"
        style="
    width: 60px !important;"
        v-model="orderQty"
        type="number"
      />
      <b-button class="order-btns" size="sm" @click="incrementOrder">
        <font-awesome-icon class="order-icons" icon="plus"></font-awesome-icon>
      </b-button>

      <b-button class="add-btn" size="sm" @click="addToOrder">Add to inquiry</b-button>
    </div>

    <div class="pt-2 available-qty-parent" v-if="selectedProduct.Avail != -1">
      <span class="available-qty-title">Qty Available &nbsp; :</span>
      <span class="available-qty">&nbsp; {{ selectedProduct.Avail }}</span>
    </div>

    <div class="pt-3" v-if="prod.colors && prod.colors.length > 1">
      <label class="font-weight-bold">Colors available:</label>
      <b-form-select v-model="selectedOption" v-on:change="changeProduct">
        <b-form-select-option
          v-for="(item, index) in prod.colors"
          :key="index"
          :value="item.Item_id"
        >{{ item.Colour }}</b-form-select-option>
      </b-form-select>
    </div>

    <div class="pt-3" v-if="prod.sizes && prod.sizes.length > 1">
      <label class="font-weight-bold">Sizes available:</label>
      <b-form-select v-model="selectedOption" v-on:change="changeProduct">
        <b-form-select-option
          v-for="(item, index) in prod.sizes"
          :key="index"
          :value="item.Item_id"
        >{{ item.Size }}</b-form-select-option>
      </b-form-select>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderSection",
  data() {
    return {
      orderQty: 1,
      Avail: 5,
      selectedOption: "",
    };
  },
  props: ["prod", "modal", "initial_product"],
  mounted() {
    this.selectedOption = this.initial_product
      ? this.initial_product
      : this.prod.Item_id;
  },
  computed: {
    selectedProduct: function () {
      if (this.prod.sizes) {
        return this.prod.sizes.find(
          (item) => item.Item_id == this.selectedOption
        );
      } else if (this.prod.colors) {
        return this.prod.colors.find(
          (item) => item.Item_id == this.selectedOption
        );
      }
      return this.prod;
    },
  },
  methods: {
    changeProduct() {
      this.$emit("change-product", this.selectedOption);
    },
    incrementOrder() {
      this.orderQty++;
    },
    decrementOrder() {
      if (this.orderQty > 1) {
        this.orderQty--;
      }
    },
    addToOrder() {
      let prod = this.selectedProduct;

      prod.orderQty = this.orderQty;
      prod.shippingOption = "Address Shipping";
      this.$store.commit("addItem", prod);
      this.$noty.success("Product successfully added");
    },
  },
};
</script>

<style scoped>
.order-btns {
  display: inline;
  margin-right: 0.5rem;
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 5px;
  padding: 10px 15px;
  opacity: 1 !important;
}

.order-icons {
  color: #000000;
}

.available-qty-title {
  text-transform: uppercase;
}
.available-qty {
  color: #3fa9f5;
  font-weight: 600;
}

.product-name {
  font: 700;
  font-size: 1.5rem;
  margin-bottom: 0;
  padding-bottom: 0;
}

.add-btn {
  border: none;
  background-color: #01b4db;
  color: #ffffff;
  border-radius: 7.5px;
  border-radius: 0.8rem;
  border: 1px solid #03b4db;
  background-color: #03b4db;
  font-weight: 100;
  height: 38px;
  margin-left: 0px;
  text-transform: uppercase;
  font-size: 13px;
}
.add-btn:hover {
  border: 1px solid #03b4db;
  background-color: white;
  color: #03b4db;
}
.custom-select {
  display: block;
  width: auto;
}
@media screen and (max-width: 768px) {
  .order--buttons {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 4fr;
  }
}
</style>
